export const getFormattedMessage = (template, i18n, cardLastFourDigits, price) => {
    return i18n.displayTextLabel(template, { cardLastFourDigits, price: i18n.currency((price === null || price === void 0 ? void 0 : price.valueIncludingTax) || 0) });
};
